import { utils } from 'ethers';
const logger = new utils.Logger("CeloNetworks");
const networks = [
    {
        name: 'celo',
        chainId: 42220,
    },
    {
        name: 'alfajores',
        chainId: 44787,
    },
    {
        name: 'baklava',
        chainId: 62320,
    },
];
export function getNetwork(network) {
    {
        if (network == null) {
            return null;
        }
        // Chain ID
        if (typeof network === 'number') {
            const matches = networks.filter((n) => n.chainId === network);
            if (matches.length) {
                return { name: matches[0].name, chainId: matches[0].chainId };
            }
            return {
                name: 'unknown',
                chainId: network,
            };
        }
        // Chain name
        if (typeof network === 'string') {
            const matches = networks.filter((n) => n.name === network);
            if (matches.length) {
                return { name: matches[0].name, chainId: matches[0].chainId };
            }
            return null;
        }
        if (typeof network.name === 'string' &&
            typeof network.chainId === 'number') {
            const byName = getNetwork(network.name);
            const byChainId = getNetwork(network.chainId);
            // Nothing standard; valid custom network
            if (byName == null && byChainId == null) {
                return {
                    name: network.name,
                    chainId: network.chainId,
                };
            }
            // Make sure if it is a standard chain the parameters match
            if (byName &&
                byChainId &&
                byName.name === byChainId.name &&
                byName.chainId === byChainId.chainId) {
                return byName;
            }
        }
        return logger.throwArgumentError('network chainId mismatch', 'network', network);
    }
}
//# sourceMappingURL=data:application/json;base64,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